import React from 'react'
import styled from 'styled-components'

import ButtonConfirm from 'components/ButtonConfirm'
import Section from 'components/Section'
import SubTitle from 'components/SubTitle'
import Select from 'components/Select'
import Tip from 'components/Tip'

import Label from 'components/Label'
import ArrowIcon from './images/ic-arrow.svg'

import { sortByEnergyClass } from 'utils'
import { GAS_AND_ELECTRICITY_OFFER_TYPE } from 'config'

/* eslint-disable camelcase */
export default class SolarSistem extends React.Component {
  constructor(props) {
    super(props)
    this.isLoading = true

    this.handleButtonSelection = this.handleButtonSelection.bind(this)
    this.handleSelectSelection = this.handleSelectSelection.bind(this)

    this.state = {
      hasCentralAirConditioning: this.props.option,
      open: this.props.option,
      centralHeatingOfferType: this.props.offerType,
      centralAirConditioningEquipment: this.props.equipment,
      centralAirConditioningEnergyClass: this.props.equipmentEnergyClass,
    }
  }

  getFirstSelectedItem(prop, values) {
    const items = values || this.props[prop]
    items &&
      items.forEach((item) => {
        if (item.status) return item
      })
    return items && items[0]
  }

  handleButtonSelection(e) {
    if (this.props.onSelectionChange && !e.first) {
      this.props.onSelectionChange({
        hasCentralAirConditioning: e.value,
        centralHeatingOfferType: this.state.centralHeatingOfferType,
        centralAirConditioningEquipment: this.state
          .centralAirConditioningEquipment,
        centralAirConditioningEnergyClass: this.state
          .centralAirConditioningEnergyClass,
      })
    }

    this.setState({
      hasCentralAirConditioning: e.value,
      centralHeatingOfferType: this.state.centralHeatingOfferType,
      centralAirConditioningEquipment: this.state
        .centralAirConditioningEquipment,
      centralAirConditioningEnergyClass: this.state
        .centralAirConditioningEnergyClass,
      open: e.value,
    })
  }
  // this is a mess refactor soon
  handleSelectSelection(prop, e) {
    let objectProps = [
      'centralAirConditioningEquipment',
      'centralAirConditioningEnergyClass',
      'centralHeatingOfferType',
    ]
    objectProps.splice(objectProps.indexOf(prop), 1)

    if (this.props.onSelectionChange && !e.first) {
      let changes = {
        hasCentralAirConditioning: this.state.hasCentralAirConditioning,
        open: this.state.hasCentralAirConditioning,
      }

      changes[prop] = e.value

      if (prop === 'centralHeatingOfferType') {
        changes.centralAirConditioningEnergyClass = null
        changes.centralAirConditioningEquipment = null
      }

      if (prop === 'centralAirConditioningEquipment') {
        changes.centralAirConditioningEnergyClass = null
      }

      this.props.onSelectionChange({ ...changes })
      this.setState({ ...changes })
    }

    let newState = {}
    newState[prop] = e.value

    this.setState({ ...newState })
  }

  render() {
    const { items, equipments, translations, iframed } = this.props
    const {
      centralHeatingOfferType,
      hasCentralAirConditioning,
      centralAirConditioningEquipment,
      centralAirConditioningEnergyClass,
    } = this.state

    const { CENTRAL_HEATING } = translations || {}

    const filteredOfferTypes =
      this.props.offerTypes &&
      this.props.offerTypes.filter(({ slug }) => {
        return slug !== GAS_AND_ELECTRICITY_OFFER_TYPE
      })

    // Get all equipments for offerType
    const filteredEquipments = centralHeatingOfferType && [
      ...equipments.filter(
        ({ offer_type }) => offer_type === centralHeatingOfferType
      ),
    ]

    // Format energyClasses
    let classes = []
    if (centralAirConditioningEquipment) {
      const equipment =
        filteredEquipments &&
        filteredEquipments.find(
          ({ id }) => id === centralAirConditioningEquipment
        )
      if (equipment && equipment.classes) {
        classes =
          equipment &&
          equipment.classes.map((el) => {
            el.label = el.classe_energetica.name
            el.value = el.id
            return el
          })
      }
    }

    classes = classes && sortByEnergyClass(classes)
    return (
      <Section
        title={`Climatização Central`}
        subtitle={`A sua habitação possui Climatização Central?`}
        grey
        compact={iframed}>
        {CENTRAL_HEATING && <Tip data-slot='tip' text={CENTRAL_HEATING} />}
        <ButtonWrapper status={this.state.open}>
          <ButtonConfirm
            onButtonClick={this.handleButtonSelection}
            value={hasCentralAirConditioning}
            items={items}
          />
        </ButtonWrapper>
        <SelectorWrapper status={this.state.open}>
          <SubTitle
            text={`Indique a fonte de energia, sistema e classe/ano da Climatização Central`}
          />
          <WrapperSelect>
            <LocationLabel fontSize='12px'>Fonte de energia</LocationLabel>
            <StyledSelect
              margin
              placeholder={'Selecione'}
              items={filteredOfferTypes}
              onChange={this.handleSelectSelection.bind(
                this,
                'centralHeatingOfferType'
              )}
              selected={centralHeatingOfferType}
              arrowIcon={ArrowIcon}
            />
          </WrapperSelect>
          <WrapperSelect>
            <LocationLabel fontSize='12px'>Sistema</LocationLabel>
            {centralAirConditioningEquipment && (
              <StyledSelect
                margin
                placeholder={'Selecione'}
                items={filteredEquipments}
                onChange={this.handleSelectSelection.bind(
                  this,
                  'centralAirConditioningEquipment'
                )}
                selected={centralAirConditioningEquipment}
                arrowIcon={ArrowIcon}
              />
            )}
            {!centralAirConditioningEquipment && (
              <StyledSelect
                margin
                placeholder={'Selecione'}
                items={filteredEquipments}
                onChange={this.handleSelectSelection.bind(
                  this,
                  'centralAirConditioningEquipment'
                )}
                selected={centralAirConditioningEquipment}
                arrowIcon={ArrowIcon}
              />
            )}
          </WrapperSelect>
          <WrapperSelect>
            <LocationLabel fontSize='12px'>
              Classe Energética / Ano
            </LocationLabel>
            {/* HOT FIX: SELECT COMPONENT IS NOT UPDATING WHEN VALUES ARE NULL FIX ASAP */}
            {centralAirConditioningEnergyClass && (
              <StyledSelect
                margin
                placeholder={'Selecione'}
                items={classes}
                onChange={this.handleSelectSelection.bind(
                  this,
                  'centralAirConditioningEnergyClass'
                )}
                selected={centralAirConditioningEnergyClass}
                arrowIcon={ArrowIcon}
              />
            )}
            {!centralAirConditioningEnergyClass && (
              <StyledSelect
                margin
                placeholder={'Selecione'}
                items={classes}
                onChange={this.handleSelectSelection.bind(
                  this,
                  'centralAirConditioningEnergyClass'
                )}
                selected={centralAirConditioningEnergyClass}
                arrowIcon={ArrowIcon}
              />
            )}
          </WrapperSelect>
        </SelectorWrapper>
      </Section>
    )
  }
}

const ButtonWrapper = styled.div`
  display: block;
  text-align: center;
  margin-bottom: 81px;
  ${({ status }) =>
    !status &&
    `
    margin-bottom: 0px;
  `}
`

const SelectorWrapper = styled.div`
  display: block;
  border-top: 1px solid #dedede;
  overflow: visible;
  padding-top: 80px;

  ${({ status }) =>
    !status &&
    `
    padding-top: 0px;
    border-top: none;
    overflow: hidden;
    height: 0px;
  `}
`

const WrapperSelect = styled.div`
  display: inline-block;
  width: auto;
  margin-top: 32px;
`

const StyledSelect = styled(Select)`
  width: 166px;
  float: left;
  max-width: 166px;

  > div {
    border: 1px solid #bababa;
    color: #3e3e3e;
  }
  ${({ margin }) => margin && `margin-right: 30px;`}
`

const LocationLabel = styled(Label)`
  text-align: left;
  padding-bottom: 5px;
`



// WEBPACK FOOTER //
// ./src/containers/CentralHeating/index.js